import { useState } from "react";
import { channels } from "@/mocks/chigua";

export default function Channels() {
  const [active, setActive] = useState(0);
  const featured = channels[active];

  return (
    <section id="channels" className="honeycomb py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <p className="mb-2 text-xs font-medium tracking-widest text-secondary-600">CHANNELS</p>
          <h2 className="font-display text-3xl text-foreground-950 md:text-4xl">
            吃瓜<span className="text-secondary-500">频道</span>
          </h2>
          <p className="mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
            按兴趣分类找到你的瓜田，剧组、综艺、红毯、音乐…想看什么直接钻进对应频道。
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {channels.map((c) => (
            <a
              key={c.id}
              href="#subscribe"
              className="group flex flex-col justify-between overflow-hidden rounded-3xl border border-background-200 bg-background-50 p-6 transition-all hover:-translate-y-1 hover:border-secondary-300 hover:shadow-[0_12px_30px_rgba(209,143,36,0.12)]"
            >
              <div>
                <span className={`flex h-12 w-12 items-center justify-center rounded-2xl text-xl ${c.color}`}>
                  <i className={c.icon}></i>
                </span>
                <h3 className="mt-4 font-display text-lg text-foreground-950">{c.name}</h3>
                <p className="mt-1 text-sm text-foreground-600">{c.desc}</p>
              </div>
              <div className="mt-5 flex items-center justify-between">
                <span className="text-xs text-foreground-500">{c.items} 条内容</span>
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-100 text-foreground-500 transition-colors group-hover:bg-secondary-500 group-hover:text-background-50">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-6 grid gap-6 overflow-hidden rounded-3xl border border-background-200 bg-background-50 p-6 md:p-8 lg:grid-cols-[1.1fr_1fr]">
          <div className="relative min-h-52 overflow-hidden rounded-2xl">
            {featured ? (
              <img
                src={
                  [
                    "https://readdy.ai/api/search-image?query=Movie%20film%20set%20backstage%20with%20cameras%20and%20soft%20lights%2C%20actors%20in%20costume%20preparing%2C%20cinematic%20teal%20and%20coral%20tones%2C%20editorial&width=1200&height=700&seq=ch-1&orientation=landscape",
                    "https://readdy.ai/api/search-image?query=Cheerful%20variety%20show%20behind%20the%20scenes%20with%20bright%20colorful%20stage%20lighting%2C%20playful%20energy%2C%20warm%20tones&width=1200&height=700&seq=ch-2&orientation=landscape",
                    "https://readdy.ai/api/search-image?query=Glamorous%20award%20red%20carpet%20with%20spotlights%20and%20photographers%2C%20elegant%20evening%20gala%2C%20warm%20golden%20ambience&width=1200&height=700&seq=ch-3&orientation=landscape",
                    "https://readdy.ai/api/search-image?query=Live%20concert%20stage%20with%20vibrant%20lights%20and%20crowd%20excitement%2C%20music%20festival%20energy%2C%20mint%20and%20amber%20tones&width=1200&height=700&seq=ch-4&orientation=landscape",
                    "https://readdy.ai/api/search-image?query=Quiet%20film%20studio%20interior%20with%20props%20and%20script%20on%20desk%2C%20moody%20warm%20lighting%2C%20storytelling%20ambience&width=1200&height=700&seq=ch-5&orientation=landscape",
                    "https://readdy.ai/api/search-image?query=Heartwarming%20cozy%20community%20scene%20with%20warm%20people%20sharing%2C%20soft%20morning%20light%2C%20gentle%20green%20tones&width=1200&height=700&seq=ch-6&orientation=landscape",
                    "https://readdy.ai/api/search-image?query=Stylish%20fashion%20street%20style%20shooting%20with%20cameras%2C%20urban%20backdrop%2C%20warm%20neutral%20tones&width=1200&height=700&seq=ch-7&orientation=landscape",
                    "https://readdy.ai/api/search-image?query=Infographic%20timeline%20research%20desk%20with%20documents%20and%20magnifying%20glass%2C%20warm%20desk%20light%2C%20focus%20detail&width=1200&height=700&seq=ch-8&orientation=landscape",
                  ][active]
                }
                alt={featured.name}
                className="absolute inset-0 h-full w-full object-cover object-center"
              />
            ) : null}
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/40 to-transparent"></div>
            <div className="absolute bottom-4 left-4">
              <p className="text-xs text-background-50/80">频道封面</p>
              <p className="font-display text-xl text-background-50">{featured.name}</p>
            </div>
          </div>

          <div className="flex flex-col">
            <p className="text-xs font-medium tracking-widest text-secondary-600">今日精选</p>
            <h3 className="mt-2 font-display text-xl text-foreground-950 md:text-2xl">
              「{featured.name}」频道热度怎么这么高？
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              吃瓜群众按兴趣圈层各就各位，把分散的线索聚成一条清晰的脉络。无论你想追一部剧的定妆路透，
              还是想蹲某场演出的现场名场面，选对频道就能精准吃到自己想吃的瓜，不错过任何一段后续。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["新鲜路透", "脉络整理", "讨论热帖"].map((t) => (
                <span
                  key={t}
                  className="inline-flex items-center gap-1 rounded-full bg-secondary-50 px-3 py-1 text-xs font-medium text-secondary-700"
                >
                  <i className="ri-price-tag-3-line text-xs"></i>
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-5 flex flex-wrap justify-center gap-2">
          {channels.map((c, i) => (
            <button
              key={c.id}
              type="button"
              onClick={() => setActive(i)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                active === i
                  ? "bg-secondary-500 text-background-50"
                  : "border border-background-300 bg-background-50 text-foreground-600 hover:border-secondary-400 hover:text-secondary-600"
              }`}
            >
              {c.name}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}